import { ModalCloseButton, ModalContent, ModalRoot, Spinner } from '@cian/ui-kit';
import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './ChatModal.css';

export interface IChatModalProps {
  src: string;
  isOpen: boolean;
  onClose(): void;
}

export const ChatModal: React.FC<IChatModalProps> = ({ src, isOpen, onClose }) => {
  const [isLoading, setIsLoading] = React.useState(true);
  const onLoad = () => setIsLoading(false);

  return (
    <ModalRoot open={isOpen} onOpenChange={onClose}>
      <ModalContent>
        <ModalCloseButton title="Закрыть" theme="fill_light" icon={<IconActionClose12 />} />
        <div className={styles['iframe-container']}>
          {isLoading && (
            <span className={styles['spinner']} data-testid="spinner">
              <Spinner size={16} />
            </span>
          )}
          <iframe data-name="ChatModal" className={styles['iframe']} src={src} onLoad={onLoad} onError={onLoad} />
        </div>
      </ModalContent>
    </ModalRoot>
  );
};
